import { render, staticRenderFns } from "./cpxlist.vue?vue&type=template&id=5cbea2d0&scoped=true"
import script from "./cpxlist.vue?vue&type=script&lang=js"
export * from "./cpxlist.vue?vue&type=script&lang=js"
import style0 from "./cpxlist.vue?vue&type=style&index=0&id=5cbea2d0&prod&scoped=true&lang=css"
import style1 from "./cpxlist.vue?vue&type=style&index=1&id=5cbea2d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbea2d0",
  null
  
)

export default component.exports